// api_keys
export const API_KEYS_VIEW_ALL = 'api_keys_view_all';

// clients
export const CLIENTS_VIEW_ALL = 'clients_view_all';

// companies
export const COMPANIES_VIEW_ALL = 'companies_view_all';

// webhook_clients
export const WEBHOOK_CLIENTS_VIEW_ALL = 'webhook_clients_view_all';

// links = invoices
export const LINKS_VIEW_ALL = 'links_view_all';

// billable_sms_notifications
export const BILLABLE_SMS_NOTIFICATIONS_VIEW_ALL =
  'billable_sms_notifications_view_all';

// caboodle_outlets
export const CABOODLE_OUTLETS_VIEW_ALL = 'caboodle_outlets_view_all';

// caboodle_payout_logs
export const CABOODLE_PAYOUT_LOGS_VIEW_ALL = 'caboodle_payout_logs_view_all';

// caboodle_payouts
export const CABOODLE_PAYOUTS_VIEW_ALL = 'caboodle_payouts_view_all';

// transactions
export const TRANSACTIONS_VIEW_ALL = 'transactions_view_all';

// payouts
export const PAYOUTS_VIEW_ALL = 'payouts_view_all';

// refunds
export const REFUNDS_VIEW_ALL = 'refunds_view_all';

// billable_sms_notifications_payments
export const BILLABLE_SMS_NOTIFICATIONS_PAYMENTS_VIEW_ALL =
  'billable_sms_notifications_payments_view_all';

// transfers
export const TRANSFERS_VIEW_ALL = 'transfers_view_all';

// chargebacks = disputes
export const CHARGEBACKS_VIEW_ALL = 'chargebacks_view_all';

// fraud_notifications = reviews
export const FRAUD_NOTIFICATIONS_VIEW_ALL = 'fraud_notifications_view_all';

// misc
// export const VIEW_ONBOARDING = 'view_onboarding';
// export const VIEW_REPORTS = 'view_reports';
// export const VIEW_STORE_ADMIN_BUTTON = 'view_store_admin_button';
